export const listMaintenanceConstants = {
  listItemMaxLength: 100,
};